import script from "./MistakeView.vue?vue&type=script&setup=true&lang=js"
export * from "./MistakeView.vue?vue&type=script&setup=true&lang=js"

import "./MistakeView.vue?vue&type=style&index=0&id=a09f6e20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a09f6e20"]])

export default __exports__